/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  PsTreeItem,
  ErrorInfo,
  PsTreeSearchConditions,
  PostPsTreeSearchParams,
  GetPsTreeDiff200
} from '.././model'


/**
 * PSツリー情報をツリー構造で取得する。

 * @summary PSツリー情報取得
 */
export const postPsTreeSearch = (
    psTreeSearchConditions: PsTreeSearchConditions,
    params?: PostPsTreeSearchParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsTreeItem>> => {
    return axios.post(
      `/pstrees/search`,
      psTreeSearchConditions,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type PostPsTreeSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postPsTreeSearch>>>
    export type PostPsTreeSearchMutationBody = PsTreeSearchConditions
    export type PostPsTreeSearchMutationError = AxiosError<ErrorInfo>

    export const usePostPsTreeSearch = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsTreeSearch>>, TError,{data: PsTreeSearchConditions;params?: PostPsTreeSearchParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsTreeSearch>>, {data: PsTreeSearchConditions;params?: PostPsTreeSearchParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postPsTreeSearch(data,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsTreeSearch>>, TError, {data: PsTreeSearchConditions;params?: PostPsTreeSearchParams}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PSツリーに含まれるPSバージョンIDリストを取得する。

 * @summary PSツリーIDリスト取得
 */
export const postPsTreeSearchList = (
    psTreeSearchConditions: PsTreeSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number[]>> => {
    return axios.post(
      `/pstrees/searchlist`,
      psTreeSearchConditions,options
    );
  }



    export type PostPsTreeSearchListMutationResult = NonNullable<Awaited<ReturnType<typeof postPsTreeSearchList>>>
    export type PostPsTreeSearchListMutationBody = PsTreeSearchConditions
    export type PostPsTreeSearchListMutationError = AxiosError<ErrorInfo>

    export const usePostPsTreeSearchList = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsTreeSearchList>>, TError,{data: PsTreeSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsTreeSearchList>>, {data: PsTreeSearchConditions}> = (props) => {
          const {data} = props ?? {};

          return  postPsTreeSearchList(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsTreeSearchList>>, TError, {data: PsTreeSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PSツリー情報の差分をツリー構造で取得する。

 * @summary PSツリー差分情報取得
 */
export const getPsTreeDiff = (
    psVersionIdSrc: number,
    psVersionIdDst: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPsTreeDiff200>> => {
    return axios.get(
      `/pstrees/diff/${psVersionIdSrc}/${psVersionIdDst}`,options
    );
  }


export const getGetPsTreeDiffQueryKey = (psVersionIdSrc: number,
    psVersionIdDst: number,) => [`/pstrees/diff/${psVersionIdSrc}/${psVersionIdDst}`];

    
export type GetPsTreeDiffQueryResult = NonNullable<Awaited<ReturnType<typeof getPsTreeDiff>>>
export type GetPsTreeDiffQueryError = AxiosError<ErrorInfo>

export const useGetPsTreeDiff = <TData = Awaited<ReturnType<typeof getPsTreeDiff>>, TError = AxiosError<ErrorInfo>>(
 psVersionIdSrc: number,
    psVersionIdDst: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsTreeDiff>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsTreeDiffQueryKey(psVersionIdSrc,psVersionIdDst);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsTreeDiff>>> = ({ signal }) => getPsTreeDiff(psVersionIdSrc,psVersionIdDst, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsTreeDiff>>, TError, TData>(queryKey, queryFn, {enabled: !!(psVersionIdSrc && psVersionIdDst), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

